import Vue from 'vue'
import VueRouter from 'vue-router'

const Home = () => import('views/home/Home')
const HomePost = () => import('views/home/HomePost')
const HomePostDefault = () => import('views/home/HomePostDefault')
const HomePostApply = () => import('views/home/HomePostApply')
const HomePostQuestionnaire = () => import('views/home/HomePostQuestionnaire')
const Score = () => import('views/home/Score')

const Search = () => import('views/search/Search')
const SearchInfo = () => import('views/search/SearchInfo')

const Sign = () => import('views/sign/Sign')
const NewSign = () => import('views/sign/NewSign')
const AllTask = () => import('views/sign/AllTask')

const Release = () => import('views/release/Release')

const Message = () => import('views/message/Message')
const MessageList = () => import('views/message/MessageList')

const Profile = () => import('views/profile/Profile')
const ProfileAchievement = () => import('views/profile/ProfileAchievement')
const ProfileAttent = () => import('views/profile/ProfileAttent')
const ProfileFans = () => import('views/profile/ProfileFans')
const ProfileColl = () => import('views/profile/ProfileColl')
const ProfileOder = () => import('views/profile/ProfileOder')
const ProfileOderDetail = () => import('views/profile/ProfileOderDetail')
const ProfileEdit = () => import('views/profile/ProfileEdit')
const ProfilePostEdit = () => import('views/profile/ProfilePostEdit')
const ProfilePrivacy = () => import('views/profile/ProfilePrivacy')
const ProfileGradeRules = () => import('views/profile/ProfileGradeRules')
const ProfileIntegralRules = () => import('views/profile/ProfileIntegralRules')
const ProfileUser = () => import('views/profile/ProfileUser')
const ProfileInfoWrittenConsent = () => import('views/profile/ProfileInfoWrittenConsent')
const ProfileClaimPoints = () => import('views/profile/ProfileClaimPoints')

const Mall = () => import('views/mall/Mall')
const MallDetail = () => import('views/mall/MallDetail')
const MallAddress = () => import('views/mall/MallAddress')
const MallRecord = () => import('views/mall/MallRecord')



Vue.use(VueRouter)

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path: '/home',
    component: Home,
    meta: {
      showTab: true,
      keepAlive: true,
      tabbarActive: 0

    }
  },
  // {
  //   path: '/sign',
  //   component: Sign,
  //   meta: {
  //     showTab: true,
  //     keepAlive: false,
  //     tabbarActive: 1

  //   }
  // },
  // {
  //   path: '/newsign',
  //   component: NewSign,
  //   meta: {
  //     showTab: true,
  //     keepAlive: false,
  //     tabbarActive: 1
  //   }
  // },
  // {
  //   path: '/alltask',
  //   component: AllTask,
  //   meta: {
  //     showTab: false,
  //     keepAlive: false,
  //     tabbarActive: 1
  //   }
  // },
  // {
  //   path: '/release',
  //   component: Release,
  //   meta: {
  //     showTab: true,
  //     keepAlive: false,
  //     tabbarActive: 2

  //   }
  // },
  {
    path: '/message',
    component: Message,
    meta: {
      showTab: true,
      keepAlive: false,
      tabbarActive: 3

    }
  },
  {
    path: '/profile',
    component: Profile,
    meta: {
      showTab: true,
      keepAlive: true,
      tabbarActive: 4
    }
  },
  {
    path: '/mall',
    component: Mall,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/malldetail',
    component: MallDetail,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/malladdress',
    component: MallAddress,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/mallrecord',
    component: MallRecord,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/homepost',
    component: HomePost,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/homepostdefault',
    component: HomePostDefault,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/profileachievement',
    component: ProfileAchievement,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/profileattent',
    component: ProfileAttent,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/profilefans',
    component: ProfileFans,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/profilecoll',
    component: ProfileColl,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/profileoder',
    component: ProfileOder,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/search',
    component: Search,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/oderDetail',
    component: ProfileOderDetail,
    meta: {
      showTab: false,
      keepAlive: false

    }
  },
  {
    path: '/edit',
    component: ProfileEdit,
    meta: {
      showTab: false,
      keepAlive: false
    }
  },
  {
    path: '/postedit',
    component: ProfilePostEdit,
    meta: {
      showTab: false,
      keepAlive: false
    }
  },
  {
    path: '/searchinfo',
    component: SearchInfo,
    meta: {
      showTab: false,
      keepAlive: false
    }
  },
  {
    path: '/privacy',
    component: ProfilePrivacy,
    meta: {
      showTab: false,
      keepAlive: false
    }
  },
  {
    path: '/graderules',
    component: ProfileGradeRules,
    meta: {
      showTab: false,
      keepAlive: false
    }
  },
  {
    path: '/integralrules',
    component: ProfileIntegralRules,
    meta: {
      showTab: false,
      keepAlive: false
    }

  },
  {
    path: '/profileuser',
    component: ProfileUser,
    meta: {
      showTab: false,
      keepAlive: false
    }
  },
  {
    path: '/messagelist',
    component: MessageList,
    meta: {
      showTab: false,
      keepAlive: false
    }
  },
  {
    path: '/homepostapply',
    component: HomePostApply,
    meta: {
      showTab: false,
      keepAlive: false
    }
  },
  {
    path: '/infowrittenconsent',
    component: ProfileInfoWrittenConsent,
    meta: {
      showTab: false,
      keepAlive: false
    }
  },
  {
    path: '/homepostquestionnaire',
    component: HomePostQuestionnaire,
    meta: {
      showTab: false,
      keepAlive: false
    }
  },
  {
    path: '/profileclaimpointsnone',
    component: ProfileClaimPoints,
    meta: {
      showTab: true,
      keepAlive: false
    }
  },
  {
    path: '/score',
    component: Score,
    meta: {
      showTab: false,
      keepAlive: false,

    }
  },
]
const router = new VueRouter({
  routes,
})



export default router